(() => {
  function init(root) {
    root.querySelectorAll('[data-pet-menu]').forEach(item => {
      if(item.dataset.menuReady)return;item.dataset.menuReady='true';
      const link=item.querySelector('.category'),panel=item.querySelector('.nav-submenu');
      const hover=matchMedia('(hover:hover) and (pointer:fine)');
      let returningFocus=false;
      link.setAttribute('aria-controls',panel.id);
      const open=value=>{panel.hidden=!value;link.setAttribute('aria-expanded',String(value));};
      open(false);
      item.addEventListener('pointerenter',e=>{if(hover.matches&&e.pointerType!=='touch')open(true);});
      item.addEventListener('pointerleave',()=>{if(!item.contains(document.activeElement))open(false);});
      item.addEventListener('focusin',()=>{if(!returningFocus)open(true);});
      item.addEventListener('focusout',e=>{if(!item.contains(e.relatedTarget))open(false);});
      item.addEventListener('keydown',e=>{
        if(e.key==='Escape'){
          e.preventDefault();open(false);
          returningFocus=true;link.focus();returningFocus=false;
        }
      });
      // Parent links retain normal collection navigation, including on touch screens.
      item.addEventListener('click',e=>{if(e.target.closest('a'))open(false);});
      document.addEventListener('click',e=>{if(!item.contains(e.target))open(false);});
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
